@if (environment.newAuthPages) {
<app-auth-shell mode="reset">
  <form [formGroup]="form" (ngSubmit)="reset()" class="auth-form">
    <h1 class="auth-title">Reset password</h1>

    @if (linkCodePresent && !form?.controls.email.valid) {
      <p class="auth-subtitle">This reset link is missing information and can't be used.</p>

      <app-warning-panel [error]='true'>This password reset link is incomplete or broken. Please request a new
        code.</app-warning-panel>

      <button type="button" class="auth-btn auth-btn-block" (click)="requestNewCode()">Request a new code</button>
    } @else {
      <p class="auth-subtitle">You can reset your password if you forgot or lost it.</p>

      <div class="auth-field">
        <label for="reset-email">Email</label>
        <input data-cy="reset-email-input" class="auth-input" id="reset-email" type="email" formControlName="email"
          required placeholder="you@company.com">
        <div class="auth-hint">Enter the email address you signed up with.</div>
        @if (form?.controls.email.invalid && form?.controls.email.touched) {
          <div class="auth-field-error">An email address is required.</div>
        }
      </div>

      <div class="auth-field">
        <label for="reset-code">Code</label>
        <input data-cy="reset-code-input" class="auth-input" id="reset-code" type="text" formControlName="code"
          required placeholder="Code" autocomplete="off">
        <div class="auth-hint">The code is sent to the email address above.</div>
        @if (form?.controls.code.invalid && form?.controls.code.touched) {
          <div class="auth-field-error">Code is required. Check your email.</div>
        }
      </div>

      <button data-cy="reset-getcode-button" type="button" class="auth-btn auth-btn-block"
        [disabled]="!form?.controls.email.valid || busy" (click)="getcode()">Get Code</button>

      @if (form?.controls.code.valid) {
        <p class="auth-subtitle">Enter your new password below.</p>

        <div class="auth-field">
          <label for="reset-password">New password</label>
          <input data-cy="reset-password-input" class="auth-input" id="reset-password" type="password"
            formControlName="password" placeholder="••••••••" required
            pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}" autocomplete="new-password" [disabled]="resetDone">
          @if (form?.controls.password.invalid && form?.controls.password.touched) {
            @if (form?.controls.password.errors?.required) {
              <div class="auth-field-error">New password is required.</div>
            }
            @if (form?.controls.password.errors?.pattern) {
              <div class="auth-field-error">Must contain at least one number and one uppercase and lowercase letter,
                and at least 8 or more characters.</div>
            }
          }
        </div>

        <div class="auth-field">
          <label for="reset-confirmpassword">Confirm new password</label>
          <input data-cy="reset-confirmpassword-input" class="auth-input" id="reset-confirmpassword" type="password"
            formControlName="confirmpassword" placeholder="••••••••" required autocomplete="new-password"
            [disabled]="resetDone">
          @if (form?.controls.confirmpassword.touched) {
            @if (form?.controls.confirmpassword.errors?.required) {
              <div class="auth-field-error">Confirm password is required.</div>
            }
            @if (form?.errors?.passwordMismatch) {
              <div class="auth-field-error">Password &amp; Confirm Password do not match and must contain at least 8
                to 100 characters.</div>
            }
          }
        </div>
      }

      @if (!resetDone) {
        <button data-cy="reset-submit-button" type="submit" class="auth-btn auth-btn-block"
          [disabled]="!form.valid || busy">Reset</button>
      } @else {
        <button type="button" class="auth-btn auth-btn-block" [routerLink]="'/signin'">Login</button>
      }

      @if (busy) {
        <simple-progress message='Requesting'></simple-progress>
      }
    }

    @if (!!message) {
      <app-warning-panel data-cy="reset-submit-message" [error]='false'>{{message}}</app-warning-panel>
    }
    @if (!!error) {
      <app-warning-panel data-cy="reset-submit-error" [error]='true'>{{error}}</app-warning-panel>
    }
  </form>
</app-auth-shell>
} @else {
<style>
  .main {
    margin-top: 10em;
  }
</style>
<app-bganimation tagName="body" className="warehouse"></app-bganimation>
<div class="main wider layout-row layout-align-center layout-justify-center">
  <form [formGroup]="form" (ngSubmit)="reset()">
    <mat-card>
      <mat-card-header>
        <mat-card-title>Reset Your Password</mat-card-title>
        <mat-card-subtitle>You can reset your password if you forgot or lost it.</mat-card-subtitle>
      </mat-card-header>
      <mat-card-content>
        <div class="layout-row-gap-1 layout-align-start">
          <div class="layout-col">
            <mat-form-field class="wide">
              <mat-label>Email Address</mat-label>
              <input data-cy="reset-email-input" type="email" matInput formControlName="email" required
                placeholder="Email">
              <mat-hint>Enter the email address you signed up with.</mat-hint>
              <mat-error>An email address is required.</mat-error>
            </mat-form-field>
            <div class="layout-row-gap-1 layout-align-center">
              <button data-cy="reset-getcode-button" mat-raised-button color="primary"
                [disabled]="!form?.controls.email.valid" (click)="getcode()">Get
                Code</button>
              <mat-form-field class="wide">
                <mat-label>Code</mat-label>
                <input data-cy="reset-code-input" type="text" matInput formControlName="code" required
                  placeholder="Code" autocomplete="off">
                <mat-hint>The code is sent to the email address above..</mat-hint>
                <mat-error>Code is required. Check your email.</mat-error>
              </mat-form-field>
            </div>
            @if (form?.controls.code.valid) {
            <mat-form-field class="wide">
              <mat-label>New Password</mat-label>
              <input data-cy="reset-password-input" type="password" matInput formControlName="password"
                placeholder="New Password" class="form-control" required pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                autocomplete="new-password" [disabled]="resetDone" />
              @if (form?.controls.password.invalid && form?.controls.password.touched) {
              <div>
                @if (form?.controls.password.errors.required) {
                <mat-error> New Password is required. </mat-error>
                }
                @if (form?.controls.password.errors.pattern) {
                <mat-error> Must contain at least one number and one
                  uppercase and
                  lowercase
                  letter,
                  and at least 8 or more characters.</mat-error>
                }
              </div>
              }
            </mat-form-field>
            }
            @if (form?.controls.code.valid) {
            <mat-form-field class="wide">
              <mat-label>Confirm New Password</mat-label>
              <input data-cy="reset-confirmpassword-input" type="password" matInput formControlName="confirmpassword"
                placeholder="Confirm New Password" required autocomplete="new-password" />
              @if (form?.controls.confirmpassword.touched) {
              <div>
                @if (form?.controls.confirmpassword.errors?.required) {
                <mat-error> Confirm password is required.
                </mat-error>
                }
                @if (form?.errors?.passwordMismatch) {
                <mat-error> Password & Confirm Password do not match and must contain at least 8 to 100
                  characters.</mat-error>
                }
              </div>
              }
            </mat-form-field>
            }
          </div>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <div class="layout-row-gap-05">
          @if (!resetDone) {
          <button data-cy="reset-submit-button" mat-raised-button type="submit" color="primary"
            [disabled]='!form.valid'>Reset</button>
          }
          @if (resetDone) {
          <button mat-stroked-button [routerLink]="'/signin'">Login</button>
          }
          <!-- <button mat-stroked-button [routerLink]="'/signup'">Register New Login</button> -->
          @if (busy) {
          <simple-progress message='Requesting'></simple-progress>
          }
          @if (!!message) {
          <app-warning-panel data-cy="reset-submit-message" [error]='false'>{{message}}
          </app-warning-panel>
          }
          @if (!!error) {
          <app-warning-panel data-cy="reset-submit-error" [error]='true'>{{error}}</app-warning-panel>
          }
        </div>
      </mat-card-actions>
    </mat-card>
  </form>
</div>
}
